/*
 * @Author: Ryan
 * @Date: 2026-01-14
 * @Description: AI Video Generator 首屏角色视频数据配置
 */

export interface CharacterVideo {
  id: string;
  name: string;
  thumbnailUrl: string;
  videoUrl: string;
  posterUrl: string;
  script: string;
}

export const CHARACTER_VIDEOS: CharacterVideo[] = [
  {
    id: 'product-demo',
    name: 'Product Demo',
    thumbnailUrl:
      'https://assets.falcocut.ai/ai-video-generator/hero-product-demo-poster.webp',
    videoUrl: 'https://assets.falcocut.ai/ai-video-generator/hero-product-demo.mp4',
    posterUrl:
      'https://assets.falcocut.ai/ai-video-generator/hero-product-demo-poster.webp',
    script:
      'A male tech creator talks directly to the camera while holding a slim power bank. Dialogue: “This is the power bank I carry every day. It’s slim, charges fast, and keeps my phone going all day. I don’t leave home without it.”',
  },
  {
    id: 'social-content',
    name: 'Social Content',
    thumbnailUrl:
      'https://assets.falcocut.ai/ai-video-generator/hero-social-content-poster.webp',
    videoUrl: 'https://assets.falcocut.ai/ai-video-generator/hero-social-content.mp4',
    posterUrl:
      'https://assets.falcocut.ai/ai-video-generator/hero-social-content-poster.webp',
    script:
      'A woman talks directly to the camera while holding a folded sweatshirt. Dialogue: “This is my favorite sweatshirt right now. It’s super soft, really comfortable, and fits perfectly. I wear it all the time.”',
  },
  {
    id: 'tutorial-video',
    name: 'Tutorial Video',
    thumbnailUrl:
      'https://assets.falcocut.ai/ai-video-generator/hero-tutorial-video-poster.webp',
    videoUrl: 'https://assets.falcocut.ai/ai-video-generator/hero-tutorial-video.mp4',
    posterUrl:
      'https://assets.falcocut.ai/ai-video-generator/hero-tutorial-video-poster.webp',
    script:
      'A woman applies makeup with a brush while speaking calmly to the camera in a soft, minimal indoor setting. Script: "I used to think good makeup takes time. But this brush changed everything. Soft strokes. Even coverage."',
  },
  {
    id: 'explainer-video',
    name: 'Explainer Video',
    thumbnailUrl:
      'https://assets.falcocut.ai/ai-video-generator/hero-explainer-video-poster.webp',
    videoUrl: 'https://assets.falcocut.ai/ai-video-generator/hero-explainer-video.mp4',
    posterUrl:
      'https://assets.falcocut.ai/ai-video-generator/hero-explainer-video-poster.webp',
    script:
      'A model wearing a metallic silver winter jacket speaks directly to the camera in a futuristic studio. Dialogue: “This jacket doesn’t just look futuristic. It’s built to keep you warm in real winter. Lightweight. Insulated. Weather-ready.”',
  },
  {
    id: 'marketing-video',
    name: 'Marketing Video',
    thumbnailUrl:
      'https://assets.falcocut.ai/ai-video-generator/hero-marketing-video-poster.webp',
    videoUrl: 'https://assets.falcocut.ai/ai-video-generator/hero-marketing-video.mp4',
    posterUrl:
      'https://assets.falcocut.ai/ai-video-generator/hero-marketing-video-poster.webp',
    script:
      'A young man and woman walk together outdoors in an urban setting, casually talking while wearing everyday jackets. Dialogue: "I really like how light this jacket is." "Yeah, and it goes with everything." "Super versatile."',
  },
];
